export function setStickyElement() {
    //sticky slider in menu

    function setSticky() {
        var stickyEl = $(".show .sticky-element");
        var parent = stickyEl.closest(".show .sticky-parent");
        if (window.innerWidth >= 568) {
            const itemHeight = stickyEl.innerHeight();
            const parentHeight = parent.innerHeight();
            parent.css("min-height", itemHeight);
            if(parentHeight > itemHeight) {
                const scroll = $(window).scrollTop();
                const headerFix = $(".header").innerHeight();
                const startPoint = parent.offset().top - headerFix;
                const endPoint = (parent.offset().top + parentHeight) - (itemHeight + headerFix);
                
                if (scroll < startPoint) {
                    stickyEl.removeClass("fixed").addClass("top");
                    
                } else if (scroll >= startPoint && scroll < endPoint) {
                    stickyEl.addClass("fixed").removeClass("top").removeClass('bottom');
                } else {
                    stickyEl.addClass("bottom");
                }
            }
            
        } else {
            stickyEl.removeClass("fixed").addClass('bottom');
            parent.attr("style", "");
        }
    }
    $(window).on("load scroll resize", setSticky);
}


// WEBPACK FOOTER //
// ./assets/js/modules/set-sticky-element.js